import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";
// import { DashboardMeasurement_dashboardMeasurement_windTurbine } from "graphql/generated";

interface IProps extends BaseCardProps {
  // data: DashboardMeasurement_dashboardMeasurement_windTurbine | undefined;
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}

const WindTurbineCard: FunctionComponent<IProps> = memo(function WindTurbine({ data, config, ...rest }) {
  const intl = useIntl();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__wind_turbine____title",
        defaultMessage: `{count, plural,
          one {Wind turbine}
          other {Wind turbines}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      image={"/images/svg/vetrnna-elektrarna.svg"}
    >
        <StatsTable
          inline
          rows={[
            {
              label: intl.formatMessage({
                id: "dashboard__wind_turbine__kw",
                defaultMessage: "Active power",
              }),
              unit: "kW",
              decimals: 2,
              // type: "number",
              value: data?.active_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__wind_turbine__kvar",
                defaultMessage: "Reactive power",
              }),
              unit: "kVAR",
              decimals: 2,
              // type: "number",
              value: data?.reactive_power,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__wind_turbine__hz",
                defaultMessage: "Frequency",
              }),
              unit: "Hz",
              decimals: 1,
              // type: "number",
              value: data?.frequency,
            },
            {
              label: intl.formatMessage({
                id: "dashboard__wind_turbine__cos",
                defaultMessage: "Power factor",
              }),
              //   unit: "°C",
              decimals: 1,
              // type: "number",
              value: data?.cos_phi,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default WindTurbineCard;
